import React from "react";
import { Redirect } from "react-router-dom";

import { useIsRouteEnabled } from "components/navigation/hooks/useIsRouteEnabled";
import { CONNECTIONS_ROUTE, deriveRedirectTarget } from "components/router/Routes";

export const ConnectionsView = () => {
    const isRouteEnabled = useIsRouteEnabled();

    const target = deriveRedirectTarget(CONNECTIONS_ROUTE, isRouteEnabled);

    return <Redirect to={target.path} />;
};
